import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchMoreLabel = () => /*#__PURE__*/_jsx(Text, {
  as: "small",
  paddingInline: "400",
  color: "icon-core-subtle",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "routing-ui.reassignment.searchForMoreUsersLabel"
  })
});
SearchMoreLabel.displayName = 'SearchMoreLabel';
export default SearchMoreLabel;